import IconKey from "assets/icons/icon_key.svg";
import IconCloseRed from "assets/icons/close-red-icon.svg";
import IconCheckWhite from "assets/icons/icon_check_white.svg";
import { theme } from "styles";

const ICON_OBJ = {
  key: IconKey,
  check: IconCheckWhite,
  close: IconCloseRed,
};

const Toast = (message, icon, fromBottom, smallFont = false) => {
  let element = document.getElementById("toasts");
  element = document.createElement("div");

  element.setAttribute("id", "toasts");
  element.style.display = "flex";
  element.style.alignItems = "center";
  element.style.width = "calc(100% - 40px)";
  element.style.height = "48px";
  element.style.position = "fixed";
  element.style.backgroundColor = "rgba(32, 36, 43, 0.8)";
  element.style.zIndex = "1000";
  element.style.bottom = fromBottom || "115px";
  element.style.margin = "0 20px";
  element.style.borderRadius = "12px";
  element.style.padding = "12px 20px";
  element.style.opacity = "1";

  const IconBox = document.createElement("div");
  if (icon) {
    IconBox.style.width = "20px";
    IconBox.style.height = "20px";
    IconBox.style.marginRight = `12px`;
    if (icon === "check") {
      IconBox.style.backgroundColor = theme.colors["primary50"];
      IconBox.style.borderRadius = "50%";
      IconBox.style.display = "flex";
      IconBox.style.alignItems = "center";
      IconBox.style.justifyContent = "center";
    }

    const IconImg = document.createElement("img");
    IconImg.src = ICON_OBJ[icon];
    if (icon === "check") {
      IconImg.style.width = "12px";
      IconImg.style.height = "12px";
    }
    IconBox.appendChild(IconImg);
  }

  const text = document.createElement("span");
  text.style.color = `#fff`;
  text.style.fontSize = smallFont ? "14px" : "16px";
  text.textContent += message;

  element.append(IconBox, text);
  document.body.appendChild(element);

  setTimeout(() => {
    element.style.opacity = "0";
    element.style.transition = "opacity 1s ease";
  }, 1000);
  setTimeout(() => document.body.removeChild(element), 2100);
};

export default Toast;
